export enum AccountStatus {
  Open = 'OPEN',
  Closed = 'CLOSED',
  UnderInvestigation = 'UNDER_INVESTIGATION',
  InReview = 'IN_REVIEW',
  AmlSuspect = 'AML_SUSPECT',
  Reported = 'REPORTED',
  WithManagement = 'WITH_MANAGEMENT',
  Freeze = 'FREEZE',
  Approved = 'APPROVED',
}
